// Get Shopify Collections
export const GET_SHOPIFY_COLLECTIONS_REQUEST = 'GET_SHOPIFY_COLLECTIONS_REQUEST';
export const GET_SHOPIFY_COLLECTIONS_DONE = 'GET_SHOPIFY_COLLECTIONS_DONE';
export const GET_SHOPIFY_COLLECTIONS_FAILED = 'GET_SHOPIFY_COLLECTIONS_FAILED';
export const GET_SHOPIFY_COLLECTIONS_RESET = 'GET_SHOPIFY_COLLECTIONS_RESET';

// Operations
export const SHOPIFY_COLLECTIONS_SET_PAGE_URL = 'SHOPIFY_COLLECTIONS_SET_PAGE_URL';
